import React from "react";
import { useSelector } from "react-redux";
import {
  deleteSessionPreference,
  getSessionPreferences,
} from "../../../redux/features/croSlice";
import GlobalDeleteDialog from "../../../components/mui/Dialogue/GlobalDeleteDialog";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";
import {
  deleteVendor,
  getAllVendors,
} from "../../../redux/features/assetManagementSlice";

const DeleteVendor = ({ id, data }) => {
  const { loading } = useSelector((state) => state.assetmanagement);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete Vendor"}
      deleteNote={"Are you sure? you want to delete this vendor data..?"}
      api={deleteVendor(id)}
      upDateCall={getAllVendors(data)}
      loading={loading}
    />
  );
};

export default DeleteVendor;
